<template>
    <div style="max-width: 600px; margin: 0 auto; text-align: left;">
        <FieldHeader class="q-mb-xs" v-if="showHeader" :field="field" />
        <q-option-group
            class="radio-group-vertical"
            type="radio"
            :options="options"
            :model-value="modelValue"
            :disable="readOnly"
            @update:model-value="onUpdate"
            :inline="field.options?.horizontal === true"
        >
            <template v-slot:label="opt">
                <div class="column items-start">
                    <div v-if="opt.label" v-html="opt.label"></div>
                    <div v-if="opt.sublabel" class="text-caption" v-html="opt.sublabel"></div>
                </div>
            </template>
        </q-option-group>
    </div>
</template>

<script>
    import FieldHeader from './FieldHeader.vue';

    export default {
        name: 'RadioField',
        components: { FieldHeader },
        props: {
            field: {
                type: Object,
                required: true,
            },
            options: {
                type: Array,
                default: () => ([]),
            },
            modelValue: {
                type: [String, Number, Boolean, Object, Array],
                default: '',
            },
            readOnly: {
                type: Boolean,
                default: false,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
        },
        emits: ['update:modelValue', 'blur'],
        methods: {
            onUpdate(value) {
                this.$emit('update:modelValue', value);
                this.$emit('blur');
            },
        },
    };
</script>

<style scoped>
    .radio-group-vertical :deep(.q-radio) {
        margin-bottom: 4px;
    }
</style>